import api from '../../../App/socket';

export const getSrSyncStatus = () => (
    api.send(
        {
            api: 'module',
            module: 'Leads',
            classMethod: 'GetSrSyncStatus',
            options: {},
        },
    )
        .then(response => response)
        .catch(error => error)
);


// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/get_sr_sync_status_request.js